import React from "react";
import { withStyles } from "@mui/styles";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import type { Url } from "@fas/cpa-cabinet-ui/lib/AppNavSidebar/AppNavSidebar.types";
import links from "./links";

const getKey = (text: string, url: string | string[]) =>
  text + (Array.isArray(url) ? url.join("") : url);

const getUrl = (url: string | string[]) =>
  Array.isArray(url) ? (url[0] as string) : url;

const StyledBottomNavigationAction = withStyles((theme) => ({
  selected: {
    background: theme.palette.transparent.light,
    "& .MuiSvgIcon-root": {
      fill: "url(#selected)",
    },
  },
  root: {
    padding: 0,
    minWidth: "55px",
  },
}))(BottomNavigationAction) as typeof BottomNavigationAction;
const StyledBottomNavigation = withStyles((theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.transparent.light}`,
    background: theme.palette.background.default,
  },
}))(BottomNavigation);

function CabinetNavBarMob() {
  const { pathname = "" } = useLocation();
  const index: number = links.findIndex(({ url }) => url.includes(pathname));
  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1,
      }}
    >
      <StyledBottomNavigation
        value={index}
        data-testid="navigation-menu-bottom"
      >
        {links.map(({ text, url, icon }: Url, i: number) => (
          <StyledBottomNavigationAction
            key={getKey(text, url)}
            data-testid={`navigation-menu-item-${text}`}
            component={RouterLink}
            to={getUrl(url)}
            icon={icon}
            value={i}
          />
        ))}
      </StyledBottomNavigation>
    </Paper>
  );
}

export default CabinetNavBarMob;
